"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var create_svg_icon_1 = require("../../../utils/create-svg-icon");
exports.default = (0, create_svg_icon_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("circle", { opacity: "0.2", cx: "12", cy: "12", r: "12", fill: "#0EB4CE" }),
    react_1.default.createElement("circle", { cx: "12", cy: "12", r: "4", fill: "#0EB4CE" })), 'check-focus', { viewBox: '0 0 24 24', fill: 'none' });
